<template>
  <v-container>
    <h2>Lessons</h2>
    <app-base
      ref="crud"
      :source="getLessons"
      :post="postLessons"
      :tableHeader="headers"
      @edit="onEdit"
      @switch="onSwitch"
      @remove="onRemove"
    >
      <template v-slot:title>Create Lesson</template>
      <template v-slot:form>
        <v-text-field
          id="name"
          v-model="name"
          label="Name"
          outlined
          dense
          :rules="[(v) => !!v || 'Name required']"
        />
        <v-select
          id="module"
          :items="modules"
          v-model="modul"
          :rules="[rules.required]"
          outlined
          dense
          label="Module"
          item-value="uuid"
        >
          <template v-slot:selection="data">{{ data.item.name }}</template>
          <template v-slot:item="data">{{ data.item.name }}</template>
        </v-select>
      </template>
    </app-base>
    <app-create-lesson v-model="dialog" :steps="steps" @edited-lesson="onEdited" />
    <app-confirm-dialog v-model="removeDialog" @yes="onYes" :loading="removeLoading" />
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import Base from "./Base.vue";
import CreateLesson from "./crud/CreateLesson.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { postLessons, getModules, getLessons, patchLesson, removeLesson } from "@/api/api";
import removeMixin from "@/mixins/removeMixin";

export default {
  components: {
    appBase: Base,
    appCreateLesson: CreateLesson,
    appConfirmDialog: ConfirmDialog,
  },
  mixins: [removeMixin],
  data() {
    return {
      rules: {
        required: (v) => !!v || "Level Required",
      },
      modules: [],
      name: "",
      modul: null,
      getLessons,
      postLessons,
      headers: [
        { text: "Lesson", value: "name", align: "left" },
        { text: "Module", value: "module_name", align: "left" },
        { text: "Created", value: "created_at", align: "right" },
        { text: "Ready", value: "switch", align: "center" },
        { text: "", value: "button", align: "right" },
        { text: "Remove", value: "remove", align: "center" },
      ],
      dialog: false,
      steps: {
        "Live Lesson": [
          "Introduction",
          "Vocabulary",
          "Listening",
          "Transcript",
          "Grammar Introduction",
          "Grammar Exercise",
          "Speaking",
          "Homework",
        ],
        "Lesson Practice": [
          "Vocabulary",
          "Listening",
          "Transcript ",
          "Pronunciation",
          "Speaking",
          "Homework",
        ],
        Grammar: ["Admin/Exercises"],
      },
      remover: removeLesson,
    };
  },
  methods: {
    async onEdit(e) {
      await this.$store.dispatch("admin/lesson", e);
      this.dialog = true;
    },
    async onSwitch({ value, item }) {
      const response = await patchLesson(item.uuid, { ready: value });
      if (!response) item.ready = !value;
    },
    onEdited(e) {
      for (let index = 0; index < this.$refs.crud.$refs.pag.data.results.length; index++) {
        const element = this.$refs.crud.$refs.pag.data.results[index];
        if (element.uuid === e.uuid) {
          element.name = e.name;
        }
      }
    },
  },
  async created() {
    try {
      let response = await getModules({ limit: 50 });
      if (response.status === 200) {
        this.modules = response.data.results;
      }
    } catch (error) {
      console.log("Error getting the lessons", error);
    }
  },
};
</script>
